import React, { useState } from 'react'

import moment from 'moment'

import { Button,Div } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import Card from 'components/Card'
import { isRunningInBrowser } from 'config/platform'
import { Timeline } from 'typings/timeline'
import { conversationUrl } from 'utils/paths'

import { segmentTrack,TrackType } from '../../../utils/tracking'

import styles from './styles.module.css'

interface Props {
  mostRecentChat: Timeline
}

const MostRecentChatSection = (props: Props) => {
  const { mostRecentChat } = props
  const [isOpen, setIsOpen] = useState(true)
  const conversation = mostRecentChat?.body?.conversation

  const handleViewChat = () => {
    if (conversation?.id) {
      segmentTrack(TrackType.CONTACT_DETAILS_VIEW_CHAT)
      if (isRunningInBrowser) {
        window.open(conversationUrl(conversation?.id))
      } else {
        window.location.href = conversationUrl(conversation?.id)
      }
    }
  }

  return (
    <Card>
      <Div className={styles.sectionHeader}>
        <Div>Most Recent Drift Chat</Div>
        <Div className={styles.collapseIcon} onClick={() => setIsOpen(!isOpen)}>
          <Icon name={isOpen ? 'chevron-down' : 'chevron-up'} width={12} />
        </Div>
      </Div>
      {isOpen && (
        <Div className={styles.sectionContent}>
          <Div className={styles.sectionStat}>
            {moment(mostRecentChat.createdAt).format('MMM D')}
          </Div>
          <Div className={styles.sectionSubline}>{moment(mostRecentChat.createdAt).fromNow()}</Div>
          {conversation?.id && (
            <Button onClick={handleViewChat} className={styles.sectionAction} type="tertiary">
              View chat
            </Button>
          )}
        </Div>
      )}
    </Card>
  )
}

export default MostRecentChatSection
